import { isRight } from 'fp-ts/lib/Either';
import { ThunkResult } from '../../../redux/configureStore';
import * as actionCreators from './actionCreators';
import { UpdatableUserAlcopaCredential } from '../../models/userModel';
import { UserDataGateway } from '../../gateways/userDataGateway.interface';

export const updateUserAlcopaUseCase =
    (updatableUserAlcopaCredential: UpdatableUserAlcopaCredential): ThunkResult<void> =>
    async (dispatch, getState, { userDataGateway }: { userDataGateway: UserDataGateway }) => {
        dispatch(actionCreators.Actions.updateAlcopaAccessRequested());
        const resultUpdate = await userDataGateway.updateUserAlcopa(updatableUserAlcopaCredential);

        if (isRight(resultUpdate)) {
            dispatch(actionCreators.Actions.updateAlcopaAccessSucceeded());
        } else {
            dispatch(actionCreators.Actions.updateAlcopaAccessFailed());
        }
    };
